import PropTypes from 'prop-types';
export default {
  sitemap: PropTypes.arrayOf(PropTypes.shape({
    groupName: PropTypes.string,
    siteLinks: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      href: PropTypes.string
    }))
  })),
  version: PropTypes.string,
  showAppIcons: PropTypes.bool,
  showSocialIcons: PropTypes.bool
};